import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';
import { get } from 'lodash';

import { AppDispatch, IStore } from '../../../../store.type';
import { changeRfiSgKYCScreen, fetchData } from '@Redux/actions/rfi/rfi-action';
import { API_URL } from '@Utils/config';
import { FORMNAME_RFI, INDIVIDUAL_POA, SG } from '@Utils/constants';
import { getSgkycFlowRfiData } from '@Redux/selectors';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger';
import ManualDocumentUpload from '../../../user-flow/individual/revampedUserFlow/manualDocumentUpload';
import { SG_ODD_SCREEN_NAMES } from '../ScreenConstants';
import { DocumentObject, DocumentOption, NestedField, RadioOptionValue } from '../types';

export const PoiPoaUploadPage: React.FC = () => {
  const [documentList, setDocumentList] = useState([]);
  const getAllformVal = useSelector((state: IStore) => getFormValues(FORMNAME_RFI)(state) || {});
  const sgKycFlowData = useSelector(getSgkycFlowRfiData);
  const personalInfoNestedFieldsJson = sgKycFlowData?.renderingObject?.values?.filter(
    (item: DocumentOption) => item.code === 'MANUAL'
  )?.[0]?.nested_fields_json;
  const permanentSgResidentValues = personalInfoNestedFieldsJson?.filter(
    (item: NestedField) => item.name === 'is_permanent_sg_resident'
  )?.[0]?.values;
  const documentListUrl =
    permanentSgResidentValues?.filter((item: RadioOptionValue) => item.label === 'No')?.[0]
      ?.values?.[0]?.url || null;

  const dispatch = useDispatch<AppDispatch>();

  const fetchDocList = async (documentListUrl: string) => {
    if (documentListUrl) {
      dispatch(activateLoader());

      const radioFieldName = sgKycFlowData?.rfiDetails?.fields_json?.[0]?.field_name || '';
      const nationality = String(
        get(getAllformVal, radioFieldName?.replace(/\.[^.]+$/, '.nationality'), '')
      );
      const isPermanentSGResident = get(
        getAllformVal,
        radioFieldName?.replace(/\.[^.]+$/, '.is_permanent_sg_resident'),
        false
      );
      const data = await dispatch(
        fetchData(API_URL, documentListUrl, {
          nationality: nationality || SG,
          ...(isPermanentSGResident ? { is_permanent_sg_resident: isPermanentSGResident } : {})
        })
      );
      if (data?.response?.status === 462) {
        dispatch(changeRfiSgKYCScreen(SG_ODD_SCREEN_NAMES.personal_info_page));
        return;
      }

      const poaDocList = data?.filter((doc: DocumentObject) => doc.type === INDIVIDUAL_POA) || [];
      setDocumentList(poaDocList);
      dispatch(disableLoader());
    }
  };

  useEffect(() => {
    fetchDocList(documentListUrl);
  }, [documentListUrl]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {documentList?.length > 0 ? (
        <ManualDocumentUpload isSgKycRfi={true} sgKycDocumentList={documentList} />
      ) : null}
    </>
  );
};
